<template>
    <div>
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3Series_mvag.svg">
            moving average
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Moving Average</h3>

                <div slot="save">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <!--
                <p class="text-grey-darker text-sm">
                                    In order to forecast the time series selected two methods are available here:<br>
                                    - Extrapolate(linear): known as "method of least squares" <br>
                                    - Extrapolate(constant):
                                    interpretation of values in tiers before the first known data point or after the
                                    last known data point
                                    here the constant extrapolation iterates the first/last known values to bring all
                                    time series selected to the same length.<br>
                                    example: series ONE starts with value A two periods later than series TWO which is
                                    two periods shorter than the fist one and ends with value B
                                    so series ONE will be extrapolated twice at the beginning by value A each and series
                                    TWO is extrapolated twice at its end by value B
                                </p>
                -->

                <div>
                    <p>Side</p>

                    <button v-for="d in directions"
                            @click="direction = d"
                            class="border mr-2 p-2 rounded"
                            :class="{'border-blue-dark': d === direction}"
                    >
                        {{ d }}
                    </button>
                </div>

                <div class="mt-8">
                    <p>Width</p>

                    <div class="flex justify-between">
                        <input class="flex-grow-1" type="range" min="1" max="100" v-model="span">
                        <span class="text-grey-dark inline-block p-2">{{ span }}</span>
                        <a class="cursor-pointer p-2 border rounded hover:border-blue-dark" @click="span--">
                            <i class="fa fa-minus"></i>
                        </a>
                        <a class="cursor-pointer p-2 border rounded hover:border-blue-dark" @click="span++">
                            <i class="fa fa-plus"></i>
                        </a>

                    </div>

                </div>

                <!--
                <a @click="toggleCopy">.. {{ isCopyMode ? 'yo' : 'no' }}</a>
                -->

            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import MovingAverageModifier from "../../modifiers/MovingAverageModifier";

    export default {
        name: "ComputeMovingAverage",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            span: 1,
            directions: ['left', 'middle', 'right'],
            direction: 'middle',
        }),

        computed: {
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
            isCopyMode() {
                return this.$store.state.series.copy;
            },
            max() {

            }
        },

        watch: {
            showModal(value) {
                if (value) {
                    this.span = 1;
                    this.direction = 'middle';
                }
            },
            span(value) {
                if (value > 100) {
                    this.span = 100;
                }
                if (value < 1) {
                    this.span = 1;
                }
                this.modify();
            },
            direction() {
                this.modify();
            },
        },

        methods: {
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (!this.showModal) {
                    return;
                }
                this.$store.dispatch('setModifier', {
                    modifier: new MovingAverageModifier({
                        span: this.span,
                        direction: this.direction,
                    }),
                    ids: this.selected
                });

            },
            toggleCopy() {
                this.$store.dispatch('toggleCopy');
                this.modify();
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
